import React from 'react';
import ReactDOM from 'react-dom/client';
import { ColorModeProvider } from './styles/ColorModeProvider';
import App from './App';
import { NotificacionProvider } from './componentes/common/NotificacionContext';
import { ConfirmProvider } from './componentes/ui/ConfirmProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ColorModeProvider>
      {/* Avisos y confirmaciones dentro del tema para heredar sus estilos */}
      <NotificacionProvider>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </NotificacionProvider>
    </ColorModeProvider>
  </React.StrictMode>
);
